export * from './components/table/table.component';
export * from './table.module';
